import EditProductForm from "components/dashboard/edit-product";
import DashboardLayout from "components/dashboard/layouts/main-layout";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLoaderData } from "react-router-dom";
import { productActions } from "store/product/product.slice";
import { convertProductResponseToProduct } from "utils/helper/product-helper";
import { ProductResponse } from "utils/types/products";

const EditProduct = () => {
  const productResponse = useLoaderData() as ProductResponse;

  const product = convertProductResponseToProduct(productResponse);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(productActions.setProduct(product));
    dispatch(productActions.setRelatedData(productResponse.relatedData));
  }, []);
  return (
    <DashboardLayout name="edit-products">
      <main className="main-content">
        <EditProductForm
          editProduct={product}
          productResponse={productResponse}
        />
      </main>
    </DashboardLayout>
  );
};

export default EditProduct;
